<div class="d-flex flex-column" style="padding: 24px">
  <div class="d-flex flex-row justify-content-start align-items-center mb-2" style="gap:12px">
    <p style="font-weight: 600; margin: 0">Ngôn ngữ mặc định của website</p>
    <nz-select style="width: 200px;" [(ngModel)]="default_language" (ngModelChange)="handleSelectDefaultLanguage($event)">
      <nz-option *ngFor="let item of language_codes" [nzValue]="item" [nzLabel]="item?.name"></nz-option>
    </nz-select>
  </div>
  <div class="d-flex flex-row justify-content-between w-100 mb-2">
    <p class="m-0" style="font-weight: 600">Đa ngôn ngữ cho website của bạn</p>
    <div class="form">
      <input type="text" placeholder="Search..." [(ngModel)]="searchLanguage" (keyup)="handleSearchLanguage(searchLanguage)" />
      <button type="submit" (click)="handleSearchLanguage(searchLanguage)"><i class="bi bi-search"></i></button>
    </div>
  </div>
  <nz-checkbox-wrapper style="width: 100%" (nzOnChange)="handleCustomMultiLanguage($event)">
    <div nz-row>
      <div nz-col nzSpan="8" *ngFor="let item of filtered_languages">
        <label nz-checkbox [(ngModel)]="item.checked" [nzValue]="item.code" [nzDisabled]="item?.code === default_language?.code">
          {{ item.name }}
        </label>
      </div>
    </div>
  </nz-checkbox-wrapper>
  <div class="_foot d-flex align-items-center justify-content-end">
    <button nz-button nzType="primary" class="button-save" (click)="handleUpdateSetUpMultiLanguage()">{{'luu' | translate}}</button>
  </div>
</div>
